var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-box"},[_c('qiun-vue-ucharts',{staticClass:"charts",attrs:{"type":"ring","opts":_vm.opts,"chartData":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }